import { twMerge } from "tailwind-merge";
import { Type } from "@shared/ui/Type";
import { RoomMember } from "@platform/features/video/types/video.types";

export type Props = {
  nameplate: string;
  isWithContentShare: boolean;
  isWithVideo: boolean;
  className?: string;
  roomMemberData?: RoomMember | null;
  isXs?: boolean;
  containerWidth?: number;
};

export function VideoUITileNameplateType({
  nameplate,
  isWithContentShare,
  isWithVideo,
  className,
  roomMemberData,
  isXs,
  containerWidth,
}: Props) {
  const nameTypeVariant =
    isWithVideo && isWithContentShare
      ? "tiny"
      : isWithVideo
      ? "small"
      : isWithContentShare
      ? "h5"
      : containerWidth && containerWidth < 240
      ? "h4"
      : containerWidth && containerWidth < 180
      ? "h6"
      : "h3";

  const pronounsTypeVariant =
    isWithVideo && isWithContentShare
      ? "tiny"
      : isWithVideo
      ? "caption"
      : isWithContentShare
      ? "small"
      : "caption";

  const roleTypeVariant =
    isWithVideo && isWithContentShare
      ? "tiny"
      : isWithVideo
      ? "caption"
      : isWithContentShare
      ? "small"
      : "caption";

  return (
    <div
      className={twMerge(
        "flex flex-col",
        isWithVideo && "gap-0",
        !isWithVideo && "gap-2"
      )}
    >
      <div
        className={twMerge(
          "flex flex-row items-center gap-1",
          !isWithVideo && "flex-col text-center"
        )}
      >
        <Type
          variant={nameTypeVariant}
          className={twMerge(
            "text-brand-50",
            nameTypeVariant === "small" && "font-medium",
            nameTypeVariant === "tiny" && "text-[0.625rem]",
            className
          )}
        >
          {nameplate}
        </Type>
        {roomMemberData?.pronouns && (
          <Type
            variant={pronounsTypeVariant}
            className={twMerge(
              "text-brand-100",
              nameTypeVariant === "tiny" && "text-[0.625rem]"
            )}
          >
            ({roomMemberData.pronouns})
          </Type>
        )}
      </div>
      {roomMemberData?.role && roomMemberData.role !== "participant" && (
        <Type
          variant={roleTypeVariant}
          className={twMerge(
            "text-brand-100",
            !isWithVideo && "text-center",
            nameTypeVariant === "tiny" && "text-[0.625rem]",
            containerWidth && containerWidth < 240 && "hidden"
          )}
        >
          {roomMemberData.role}
        </Type>
      )}
    </div>
  );
}

export default VideoUITileNameplateType;
